import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["gameSelect", "trackField"]

  connect() {
    this.filterTracks()
  }

  filterTracks() {
    const game = this.gameSelectTarget.value
    const field = this.trackFieldTarget

    if (!game) {
      field.style.display = "none"
      // Clear selection via track-select controller
      const trackSelect = this.trackSelectController
      if (trackSelect) trackSelect.filterByGame("")
      return
    }

    field.style.display = ""
    const trackSelect = this.trackSelectController
    if (trackSelect) trackSelect.filterByGame(game)
  }

  get trackSelectController() {
    const el = this.trackFieldTarget.querySelector(
      "[data-controller*='track-select']",
    )
    if (!el) return null
    return this.application.getControllerForElementAndIdentifier(
      el,
      "track-select",
    )
  }
}
